import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {StoryHashData} from "./story-hash-data";
import {OverlayService} from "../overlay/overlay.service";
import {StoryComponent} from "./story/story.component";
import {DataService} from "../services/data.service";
import {take} from "rxjs";
import {Story} from "../interfaces/story";
import {StoryTheme} from "./card/story-theme";
import {ImageService} from "../atoms/image/image.service";
import {StoryCardLayout} from "./card/story-card-layout";

@Injectable({
  providedIn: 'root'
})
export class StoryService {

  public readonly STORIES_OVERVIEW_ENDPOINT = "einblicke";
  constructor(
    private router: Router,
    private overlayService: OverlayService,
    private data: DataService,
    private image: ImageService
  ) { }

  public getStoryHashLink(storyId: number, cardIndex: number): string {
    return btoa(`story-${storyId}-${cardIndex}`);
  }
  public activateStoryFromUrl(): void {
    const possibleStoryData = this.getStoryStateFromUrl();
    if(possibleStoryData !== null) {
      this.data.getAllStories().pipe(take(1)).subscribe((allStories) => { // TODO this is bad solution, but for now there is no methode to get story by id
        const targetStory = allStories.filter((el) => el.id === possibleStoryData.id);

        if(targetStory.length) {
          this.overlayService.addComponent({
            component: StoryComponent,
            data: {
              story: targetStory[0],
              initialSlide: possibleStoryData.cardIndex
            }
          })
        }
      })
    }
  }
  private getStoryStateFromUrl(): StoryHashData | null {
    let urlHash = window.location.hash;
    // console.log(btoa("story-1-1"));
    if(urlHash && urlHash.length) {
      if(urlHash[0] === "#") urlHash = urlHash.slice(1);
      let decodedHash = "";
      try {
        decodedHash = atob(urlHash);
      } catch (err) {
        console.error(err);
        return null;
      }
      if(decodedHash.includes("story")) {
        const storyDataArr = decodedHash.split("-"); // format: story-ID-IDX
        const storyDataArrLength = storyDataArr.length;
        if(storyDataArrLength > 1) {
          const storyID = parseInt(storyDataArr[1]);
          if(!isNaN(storyID)) {
            let cardIndex = 1;
            if(storyDataArrLength === 3) {
              const parsedCardIndex = parseInt(storyDataArr[2]);
              if(!isNaN(parsedCardIndex)) cardIndex = parsedCardIndex;
            }
            return {
              id: storyID,
              cardIndex: cardIndex
            }
          }
        }
      }
    }

    return null;
  }

  public getBaseStoriesOverviewUrl(): string {
    return `/${this.STORIES_OVERVIEW_ENDPOINT}`;
  }

  getDummyStory() {
    let parsedStory: Story = {
      id:  -1,
      bicId: -1,
      title: "Dummy",
      portrait: "",
      color: StoryTheme.DARKBLUE,
      icon: {
        iconValue: "",
        color: ""
      },
      gradient: "",
      cards: [{
        title: "",
        theme: StoryTheme.DARKGREEN,
        time: "",
        text: "",
        layout: StoryCardLayout.HIGHLIGHT,
      }],
      user: {
        avatar: this.image.mapRawImageData(null),
        position: ""
      },
      nextStories: {
        stories: [],
        title: "",
        description: ""
      },
      vrDirectLink: "",
      schoolProfileUuid: ""
    }

    return parsedStory;

  }

}
